module.exports = __webpack_public_path__ + "img/gradient_load.684be078.gif";